// formatCandidateName returns the display name for a candidate in the chosen
// format. Falls back to the denormalized `name` field when first/last aren't
// both present — keeps legacy rows (imported without structured names)
// rendering correctly.
//
// format: "firstLast" | "lastFirst"
export function formatCandidateName(c, format = "firstLast") {
  if (!c) return "";
  const first = c.firstName?.trim();
  const last = c.lastName?.trim();
  if (!first || !last) return c.name ?? "";
  return format === "lastFirst" ? `${last}, ${first}` : `${first} ${last}`;
}
